export const serializeMailGroup = mailGroup => ({
  id: String(mailGroup.id),
  title: mailGroup.title,
  skillGroupId: mailGroup.skill_group_id,
});

export const serializeMailGroups = mailGroups =>
  mailGroups.map(mailGroup => serializeMailGroup(mailGroup));
